import { useOnboarding } from "@/react/components/CommunityOnboarding/useOnboarding";
import { CommunityOnboardingGettingStartedSection } from "@/react/components/Layout/CommunityOnboardingGettingStartedSection";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import { PostsSection } from "./PostsSection";
import { UpcomingEventsSection } from "./UpcomingEventsSection";

export const HomeRightSidebar = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const { isOnboardingAvailable } = useOnboarding();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  return (
    <div className="homepage__sidebar">
      {isAdmin && (
        <>
          {isOnboardingAvailable && (
            <CommunityOnboardingGettingStartedSection />
          )}
        </>
      )}
      <UpcomingEventsSection />
      <PostsSection />
    </div>
  );
};
